<script setup lang="ts">
import { cn } from '@/utils'

withDefaults(
  defineProps<{
    isLoading?: boolean
    absolute?: boolean
    loaderClassNames?: string
    classNames?: string
  }>(),
  {
    isLoading: false,
    absolute: false,
    classNames: '',
    loaderClassNames: 'size-12',
  }
)
</script>

<template>
  <div
    v-if="isLoading"
    :class="
      cn('inset-0 z-50 flex items-center justify-center bg-white/80', absolute ? 'absolute' : 'fixed', classNames)
    "
  >
    <div class="flex items-center justify-center">
      <div :class="['border-accent animate-spin rounded-full border-t-4', loaderClassNames]"></div>
    </div>
  </div>
</template>
